import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, createMigrate } from "redux-persist";
import loadingReducer from "../features/loading/loadingSlice";
import atsReducer from "../features/ats/atsSlice";
import peristReducer from "../features/persist/persistSlice";
import storage from "redux-persist/lib/storage";
import { normalizeTradeGridLayout } from "../constants/grid.layout";

const migrations = {
  1: (state) => state,
  2: (state) => {
    if (!state?.persist) return state;
    const persist = { ...state.persist };
    if (persist.gridLayout) {
      persist.gridLayout = normalizeTradeGridLayout(persist.gridLayout);
    }
    if (Array.isArray(persist.layoutList) && persist.layoutList.length) {
      persist.layoutList = persist.layoutList.map((workspace) => ({
        ...workspace,
        layout: normalizeTradeGridLayout(workspace.layout),
      }));
    }
    return { ...state, persist };
  },
};

const combinedReducer = combineReducers({
  loading: loadingReducer,
  ats: atsReducer,
  persist: peristReducer
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["persist"],
  version: 2,
  migrate: createMigrate(migrations, { debug: false }),
};
const persistedReducer = persistReducer(persistConfig, combinedReducer);

const rootReducer = (state, action) => {
  // if (action.type === "users/logoutUser") {
  //   //this is use for clearing persist reducer
  //   storage.removeItem("persist:root");
  //   state = undefined;
  //   window.location.reload();
  // }
  return persistedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer
});
